import { Navigate } from 'react-router-dom';
import authService from '../services/AuthService';

export default function AdminRoute({ children }) {
  const user = authService.getUser();

  if (!authService.isAuthenticated() || user?.role !== 'ADMIN') {
    return <Navigate to="/" replace />;
  }

  return children;
}
